const ListTreeIcon = () => {
    return (
      <>
          <svg stroke="currentColor" fill="none" strokeWidth={2} viewBox="0 0 24 24" className="h-6 w-6" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" strokeWidth={2} d="M4,1 L10,1 L10,7 L4,7 L4,1 Z M16,11 L20,11 L20,15 L16,15 L16,11 Z M16,19 L20,19 L20,23 L16,23 L16,19 Z M7,7 L7,21 L16,21 M7,13 L16,13"></path></svg>
      </>
    )
  }
  
  export default ListTreeIcon